import { render, staticRenderFns } from "./OrganizationPhoneNumberTable.vue?vue&type=template&id=08cd38fc&"
import script from "./OrganizationPhoneNumberTable.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPhoneNumberTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cd38fc')) {
      api.createRecord('08cd38fc', component.options)
    } else {
      api.reload('08cd38fc', component.options)
    }
    module.hot.accept("./OrganizationPhoneNumberTable.vue?vue&type=template&id=08cd38fc&", function () {
      api.rerender('08cd38fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/phone-number/OrganizationPhoneNumberTable.vue"
export default component.exports